module.exports = __webpack_public_path__ + "static/media/SDA.0da48518.svg";